import React, { useEffect, useRef, useState } from 'react'
import Modal from '../../../../Modal/Modal';
import Button1 from '../../../Button/Button1'
import RoundedInput from "./RoundedInput"

import classes from "./ScheduledAction.module.css"
import SaveButtonclass from "../CreateRule/SelectOutputs.module.css";
import Button2 from '../../../Button/Button2';
import { UseConvertScheduleTimezone } from '../../../../hooks/UseConvertScheduleTimezone';
const ScheduledAction = React.forwardRef(({ body, OutPutOptions, title, isReminder, nextPage, onSubmit, DeleteSchedule, showRemoveScheduleButton }, ref) => {

    const [firstPinText, setFirstPinText] = useState(OutPutOptions[0].pinName)

    useEffect(() => {
        const PinsPinNames = OutPutOptions.find(output => output.Pin == body.pin[0]);
        setFirstPinText(PinsPinNames.pinName)
    }, [body])

    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // schedules created before timezone support have no stored timezone - treat them as already being in the browser's timezone
    const scheduleTimeZone = body?.timezone || browserTimeZone;

    let currentlySetTime;
    let currentlySetTimeArray;
    let currentlySetDays;

    // spilt time into hours and minutes, to populate displayed time. For edit view - converted from the schedule's stored timezone to the viewer's local timezone
    if (body && body.time != "") {
        const converted = UseConvertScheduleTimezone(body.time, body.days, scheduleTimeZone, browserTimeZone);
        currentlySetTime = converted.time;
        currentlySetTimeArray = currentlySetTime.split(":");
        currentlySetDays = converted.days;
    }

    //variables
    const [daysSelected, setdaysSelected] = useState(currentlySetDays || body.days || ["0", "1", "2", "3", "4", "5", "6"]);
    const [isAutoArmed, setIsAutoArmed] = useState(body.action == "Disarm" ? false : true || false);
    const [isAutomationActive, setIsAutomationActive] = useState(body.active || 1);
    const [hour, setHour] = useState(currentlySetTimeArray && currentlySetTimeArray[0] || '12');
    const [minutes, setMinutes] = useState(currentlySetTimeArray && currentlySetTimeArray[1] || "00");

    //edit state
    const [editTime, setEditTime] = useState(false)


    const HandelOnClick = () => {

        const actionString = HandlePrepareAction();

        const isActive = HandlePrepareIsActive();

        const localTime = HandlePrepareTime();

        if (localTime == "00:00"){

        }

        // convert the time/days entered in the viewer's local timezone back to the schedule's stored timezone before saving
        const { time, days } = UseConvertScheduleTimezone(localTime, daysSelected, browserTimeZone, scheduleTimeZone);

        const isExistingSchedule = Boolean(body?.id);
        const Body = { ...body, days: days, time: time, active: isActive, action: actionString, reminder: isReminder };

        // the update endpoint doesn't accept a timezone value - a schedule's timezone is fixed at creation and can't be changed via edit
        if (isExistingSchedule) {
            delete Body.timezone;
        } else {
            Body.timezone = scheduleTimeZone;
        }

        onSubmit(Body);
    }

    const HandlePrepareTime = () => {

        if (hour == "00" && minutes == "00"){
            return "23:59";
        }

        return hour + ":" + minutes;
    }


    const HandlePrepareIsActive = () => {
        return + isAutomationActive; // returns 1 if isAutomationActive is true, and 0 if it's false, regardless of its initial type.
    }

    const HandlePrepareAction = () => {
        return isAutoArmed ? "Arm" : "Disarm";
    }

    const HandleResetAllStates = () => {
        setIsAutoArmed(true)

        setIsAutomationActive(false)
        setEditTime(false)
        setHour(currentlySetTimeArray[0]);
        setMinutes(currentlySetTimeArray[1]);
    }

    // Expose the method to the parent component using ref
    React.useImperativeHandle(ref, () => ({
        HandleResetAllStates: HandleResetAllStates
    }));

    const HandleOnDayClicked = (dayIndex) => {
        const isDayAlreayClicked = daysSelected.find(Day => Day == dayIndex);

        if (isDayAlreayClicked) {
            removeItem(dayIndex)
        } else {
            addItem(dayIndex)
        }
    }

    const addItem = (dayIndex) => {
        // Create a copy of the current array
        const newArray = [...daysSelected];
        // // Push the new item to the copy
        newArray.push(dayIndex);

        // // Set the state with the new array
        setdaysSelected(newArray);

    };

    const removeItem = (dayIndex) => {
        // Create a copy of the current array
        const newArray = [...daysSelected];

        const filterArray = newArray.filter(Day => Day !== dayIndex)

        // Set the state with the new array
        setdaysSelected(filterArray);
    }

    const Days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];


    // ---------------------------- Set Time Logic ------------------------------------------
    useEffect(() => {

        // if the hour input is left blank - repopulate it with previous value
        if (hour == "" || hour == null || hour == undefined) {
            setHour(currentlySetTimeArray[0]);
        }

        // if the Minutes input is left blank - repopulate it with previous value
        if (minutes == "" || minutes == null || minutes == undefined) {
            setMinutes(currentlySetTimeArray[0]);
            setMinutes(currentlySetTimeArray[1]);
        }

        const hourAsString = hour.toString(); // Convert number to string
        const hourAsStringLength = hourAsString.length;

        //if 00:00 set to 23:59


        // make sure hour are not 1 but 01
        if (hourAsStringLength < 2) {
            const newHour = 0 + hour
            setHour(newHour);
        }

        const minutesAsString = minutes.toString(); // Convert number to string
        const minutesAsStringLength = minutesAsString.length;
        // make sure minutes are not 1 but 01
        if (minutesAsStringLength < 2) {
            const newHour = 0 + minutes
            setMinutes(newHour);
        }

        if (hourAsString == "00" && minutesAsString == "00"){
            //invalid
            setHour(23);
            setMinutes(59);
        }
    }, [editTime])

    const handleChangeHour = (event) => {
        const newValue = event.target.value;
        if (newValue === "") {
            setHour("");
            return;
        }
        if (IsValueValid(newValue) && IsHourValueValid(newValue)) {
            setHour(newValue)
        }
    };

    const handleChangeMinutes = (event) => {
        const newValue = event.target.value;
        if (newValue === "") {
            setMinutes("");
            return;
        }
        if (IsValueValid(newValue) && IsMinuteValueValid(newValue)) {
            setMinutes(newValue);
        }
    };

    const IsValueValid = (value) => {
        // check if value is int and the length is not more than 2 characters
        if ((/^\d*$/.test(value) && value.length <= 2)) {
            return true;
        } else {
            return false
        }
    }

    const IsHourValueValid = (value) => {
        // check if value is with 24 hour range
        if (value >= 0 && value <= 23) {
            return true;
        }
    }

    const IsMinuteValueValid = (value) => {
        // check if value is with 24 hour range
        if (value >= 0 && value < 60) {
            return true;
        } else {
            return false
        }
    }

    const getValueLength = (value) => {
        const numberAsString = value.toString(); // Convert number to string
        const numberLength = numberAsString.length;
        if (numberLength < 2) {
            return true
        } else {
            return false;
        }

    }
    //-------------------------------------------------------------------------------------------


    //if newValue < 10 0 + newValue || if newValue >


    //to change the background colour of the removebutton when hovering over it.
    const [onMouseEnterRemove, setOnMouseEnterRemove] = useState()

    return (
        <div>
            <div className={classes.verticalFlex}>
                <div className={classes.verticalFlex}>
                    {isReminder == 1 && (
                        <p style={{ margin: "0px"}}>Remind me if</p>
                    )}
                    <h4 style={{ margin: "0px", fontWeight: "600", fontSize:"18px", width: "fit-content", color:"#6e6e6e" }} >{firstPinText}</h4>
                    {isReminder == 0 && (
                        <p>will be</p>
                    )}

                    {isReminder == 1 && (
                        <p style={{ margin: "0px"}}>is still</p>
                    )}

                    <div className={classes.horizontalFlex} >
                        <Button2 style={{ minWidth: "110px", backgroundColor: isAutoArmed && "var(--Primary-Color)", color: isAutoArmed && "white" }} onClick={() => setIsAutoArmed(true)}>{isReminder == 1 ? "Disarmed" : "Auto Armed"}</Button2>
                        <Button2 style={{ minWidth: "110px", backgroundColor: !isAutoArmed && "var(--Primary-Color)", color: !isAutoArmed && "white" }} onClick={() => setIsAutoArmed(false)}>{isReminder == 1 ? "Armed" : "Auto Disarmed"}</Button2>
                    </div>

                    <div className={classes.verticalFlex}>
                        <h4 style={{ margin: "0px", fontWeight: "400", width: "fit-content", color:"#6e6e6e" }} >at</h4>
                        {!editTime ? <h2 onClick={() => setEditTime((prevEditTime) => !prevEditTime)} style={{ margin: "5.8px", fontWeight: "500", cursor: "pointer", color:"#6e6e6e", fontSize:"30px"}}>{hour + ":" + minutes || "12:00"}</h2> :
                            <div className={classes.horizontalFlex}>
                                <RoundedInput value={hour} onChange={handleChangeHour} placeholder={hour || "12"} />
                                :
                                <RoundedInput value={minutes} onChange={handleChangeMinutes} placeholder={minutes || "00"} />
                                <div style={{ textAlign: "center", borderRadius: "50%", border: "1px solid grey", width: "20px", height: "fit-content", cursor: "pointer" }} onClick={() => setEditTime(false)}>X</div>
                            </div>
                        }
                    </div>
                </div >

                <div className={classes.verticalFlex}>
                    <h4 style={{ margin: "0px", fontWeight: "400", textAlign: "center", color:"#6e6e6e" }}>Repeat:</h4>
                    <ul className={classes.horizontalFlex}>
                        {["0", "1", "2", "3", "4", "5", "6"].map((dayIndex, index) => (

                            <li key={index}>
                                <Button2 style={{ backgroundColor: daysSelected.find(Day => Day == dayIndex) && "var(--Primary-Color)", color: daysSelected.find(Day => Day == dayIndex) && "white", minWidth:"60px", minHeight:"30px" }} onClick={() => HandleOnDayClicked(dayIndex)}>{Days[dayIndex]}</Button2>
                            </li>
                        ))}
                    </ul>
                    {<h4 style={{ margin: "0px", fontWeight: "400", width: "fit-content", color:"#6e6e6e" }} >{`Unselect days you do not want ${isReminder == 0 ? "schedule" : "reminder"} to run`}</h4>}

                </div>

                <div className={classes.verticalFlex} style={{ gap: "15px" }}>
                    {/* <Button2 
                        style={{ minWidth: "110px", backgroundColor: isAutomationActive && "var(--Primary-Color)", color: isAutomationActive && "white" }} 
                        onClick={() => setIsAutomationActive((prevIsAutomation) => !prevIsAutomation)}>
                        {isAutomationActive ? "Active" : "Click to activate"}
                    </Button2> */}
                    
                    {/* <Button2 
                        style={{ minWidth: "110px" }} 
                        onClick={() => nextPage(3)}>
                        {firstPinText}
                    </Button2> */}

                    <div style={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center", 
                        gap: "15px" 
                        }}>
                        {showRemoveScheduleButton && (
                           <Button2 
                                onMouseEnter={() => setOnMouseEnterRemove(true)} 
                                onMouseLeave={() => setOnMouseEnterRemove(false)} 
                                style={{ backgroundColor: onMouseEnterRemove ? "red" : "#FF5a5a", marginTop:"30px" }} 
                                onClick={DeleteSchedule}>
                                {"Remove " + title}
                            </Button2>
                        )}

                        <Button2 
                            style={{ minWidth: "300px", marginTop: "10px" }} 
                            disabled={daysSelected.length === 0} 
                            className={SaveButtonclass.SaveButton} 
                            onClick={HandelOnClick}>
                            {"Save"}
                        </Button2>
                    </div>
                </div>
            </div >
        </div>
    )
})

export default ScheduledAction